// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  environmentName: 'testing',
  portalURL: 'https://controllerapi-testing02.input4you.be',
  controllerAPI: 'https://PROJECTNAME-controllerapi-testing02.input4you.be',
  apiUrl: 'https://fileservice-testing02.input4you.be/api/', //production link // TODO change name
  loginUrl: 'https://login.input4you.be/LoginAPI/',
  viewerURL: 'https://viewer-testing.input4you.be',
  searchUrl: 'https://search-testing02.input4you.be',
  queueRelay: 'https://queue-relay-testing02.input4you.be',
  qualityUrl: 'https://quality-testing02.input4you.be',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
